import ImgDescCard from 'components/ImgDescCard';
import styled from 'styled-components';
import { vw } from 'components/common/Common';

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 41px;
  background: #fff;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    color: #050a30;
  }
`;

const PrimaryButton = styled(Link)`
  background: #1f68db;
`;

const NumberList = styled.ol`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #ffffff;
  border-radius: 2px;
  overflow: hidden;
`;

const NumberItem = styled.li`
  display: grid;
  grid-template-columns: ${vw(64)} 1fr;
  align-items: center;
  gap: ${vw(32)};
  padding: ${vw(16)} ${vw(12)};
  border-bottom: 1px solid #dde2e4;
  background: #f8fafc;
  &:last-child {
    border-bottom: none;
  }
`;

const ItemIndex = styled.span`
  font-size: 40px;
  font-weight: 600;
  color: #050a30;
`;

const ItemText = styled.p`
  margin: 0;
  font-size: ${vw(20)};
  color: #050a30;
  line-height: normal;
`;

const WhyChoose = () => {
  return (
    <ImgDescCard
      isLeft
      imgSrc="/imgs/webp/jetCard/sunset.webp"
      imgAlt="view of the wing on a private jet at sunset"
      title="Why Choose Airacer?"
    >
      <NumberList>
        {[
          '24/7/365 Customer Support with Multilingual Assistance, Including Mandarin',
          'Personalized White-Glove Service and Accessibility Assistance',
          'In-Flight Catering for Quick Flights and Extended Travel',
          'High-Speed Internet and Entertainment Systems Onboard Domestic Flights',
          'Luxurious Private Jet Travel at a Price You Love',
        ].map((text, idx) => (
          <NumberItem key={idx}>
            <ItemIndex>{String(idx + 1).padStart(2, '0')}.</ItemIndex>
            <ItemText>{text}</ItemText>
          </NumberItem>
        ))}
      </NumberList>
      <PrimaryButton href="/contactUs">Get your Jet card</PrimaryButton>
    </ImgDescCard>
  );
};

export default WhyChoose;
